import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { DataTable } from "../ui/dataTable";
import { BiddingDeveloperProps } from "./BiddingSummaryView";
import { useNavigate, useParams } from "react-router-dom";

function BiddingDeveloperSummaryView(props: BiddingDeveloperProps) {
  const navigate = useNavigate();
  const { project_id } = useParams<{ project_id: string }>();

  const onCompare = () => {
    navigate(`/project/${project_id}/bidding/compare`, {
      state: { ids: props.selectedRows },
    });
  };

  const onViewChart = () => {
    navigate(`/project/${project_id}/bidding-chart`)
  }


  return (
    <div className="relative">
      <div>
        <div className="absolute -top-[55px] right-0">
          <Button variant="outline" type="button" onClick={onViewChart} className="mr-3">
          View chart
          </Button>
          <Button variant="outline" type="button" onClick={onCompare}>
            Compare
          </Button>
        </div>
      </div>
      <div>
        <DataTable
          data={props.tableData}
          columns={props.tableColumns}
          handleRowClick={props.handleRowClick}
        />
      </div>
    </div>
  );
}

export default BiddingDeveloperSummaryView;
